<template>
  <button
    type="button"
    class="flex w-full items-center gap-4 rounded-xl border border-solid border-gray-200 bg-white px-4 py-3 text-left"
    @click="emit('select')"
  >
    <span
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600"
    >
      <slot name="icon"></slot>
    </span>
    <span class="min-w-0 flex-1">
      <span class="block truncate text-base font-semibold text-gray-900">
        {{ title }}
      </span>
      <span class="block truncate text-sm text-gray-500">{{ status }}</span>
    </span>
    <ChevronRight class="h-3 shrink-0 text-gray-400" />
  </button>
</template>

<script setup lang="ts">
import ChevronRight from "@/images/chevron-right.svg?component";

// One card on the scheduler's settings sheet: a glyph, what it opens, one line
// of the state it is in, and the chevron that says it leads somewhere. A real
// <button> rather than a div with a role, so Enter and Space activate it and
// the tap target is focusable without any handler of our own.
defineProps<{ title: string; status: string }>();

const emit = defineEmits<{
  (e: "select"): void;
}>();
</script>
